module.exports = __webpack_public_path__ + "fdeb23579d93b43c2afa3bf19073e418.png";